import { CardStatus, CardStatusChangedReason } from '@aslanpay/portal-common-lib';

export const CardStatusValues: Record<CardStatus, { color: string; value: string }> = {
  CREATED: { color: 'disabled', value: 'Not activated' },
  PENDING_ACTIVATION: { color: 'invited', value: 'Pending' },
  ACTIVATED: { color: 'active', value: 'Active' },
  ACTIVATING: { color: 'invited', value: 'Activating' },
  BLOCKED: { color: 'left', value: 'Blocked' },
  BLOCKING: { color: 'invited', value: 'Blocking' },
  SUSPENDED: { color: 'warning', value: 'Suspended' },
  SUSPENDING: { color: 'invited', value: 'Suspending' },
  RISK: { color: 'deleted', value: 'Risk' },
  STOLEN: { color: 'deleted', value: 'Stolen' },
  LOST: { color: 'deleted', value: 'Lost' },
  EXPIRED: { color: 'warning', value: 'Expired' },
  FRAUD: { color: 'deleted', value: 'Fraud' },
  LOCKED: { color: 'left', value: 'Locked' },
  LOCKING: { color: 'invited', value: 'Locking' },
  UNLOCKING: { color: 'invited', value: 'Unlocking' },
  DELETING: { color: 'invited', value: 'Deleting' },
};

export const CardStatusChangedReasonValues: Record<
  CardStatusChangedReason,
  { color: string; value: string }
> = {
  SYSTEM_LOCK: { color: 'paused', value: 'System locked' },
  ADMIN_LOCK: { color: 'paused', value: 'Locked by an admin' },
  EMPLOYEE_FREEZE: { color: 'paused', value: 'Frozen by an employee' },
  EMPLOYEE_LEAVING: { color: 'paused', value: 'Card deleting in 60 days' },
  USER_APP_FREEZE: { color: 'paused', value: 'Frozen by an employee' }, // TODO: Remove this one after fixing on backend and mobile app
  USER_LEAVING: { color: 'paused', value: 'Card deleting in 60 days' }, // TODO: Remove this one after fixing on backend and mobile app
};
